const CHOCO_URL = import.meta.env.VITE_CHOCO_URL;
const ELEVATE_URL = import.meta.env.VITE_ELEVATE_URL;

export const GET_JOB_APPLICATIONS = `${CHOCO_URL}/ops/applicants`;
export const GET_JOB_APPLICATION_BY_ID = (id: string) =>
  `${CHOCO_URL}/ops/applicants/${id}`;
export const GET_JOB_LISTINGS = `${CHOCO_URL}/ops/joblistings`;
export const GET_AGENT_LIST = `${CHOCO_URL}/ops/agents`;
export const GET_BRAND_LIST = `${CHOCO_URL}/ops/brands`;
export const GET_AGENT_LOGS = (
  agentId: string,
  account: string,
  month: string,
  year: string,
  offset?: number
) =>
  `${CHOCO_URL}/tracker/v2/logs?agentId=${agentId}&account=${account}&month=${month}&year=${year}&offset=${offset}`;

export const LOGIN = `${CHOCO_URL}/ops/login`;
export const VERIFY_TOKEN = `${CHOCO_URL}/user/verify-token`;

export const ADD_BRAND = `${CHOCO_URL}/ops/add/brand`;
export const GET_REQUIREMENTS = `${CHOCO_URL}/ops/requirements`;
export const GET_REQUIREMENT_BY_ID = (reqId: string) =>
  `${CHOCO_URL}/ops/requirement/${reqId}`;
export const ADD_REQUIREMENT = `${CHOCO_URL}/ops/add/requirement`;
export const DELETE_REQUIREMENT = `${CHOCO_URL}/ops/requirement`;
export const ADD_AGENT = `${CHOCO_URL}/ops/add/agent`;
export const ADD_JOB_LISTING = `${CHOCO_URL}/ops/create/job`;
export const UPDATE_JOB_LISTING = `${CHOCO_URL}/ops/update/joblisting`;
export const DELETE_JOB_LISTING = `${CHOCO_URL}/ops/joblisting`;

export const UPDATE_JOB_STATUS = `${CHOCO_URL}/ops/update/candidateStatus`;
export const UPDATE_AGENT = `${CHOCO_URL}/ops/update/agent`;
export const UPDATE_BRAND = `${CHOCO_URL}/ops/update/brand`;
export const UPDATE_JOB_APPLICATION = `${CHOCO_URL}/ops/update/jobapplication`;
export const UPDATE_AGENT_PASSWORD = `${CHOCO_URL}/ops/update/agent/password`;
export const UPDATE_AGENT_LOG = `${CHOCO_URL}/ops/update/agent/log`;
export const UPDATE_REQUIREMENT = `${CHOCO_URL}/ops/update/requirement`;

export const GET_AGENT_BRAND = (agentId: string, brandId: string) =>
  `${CHOCO_URL}/ops/agentBrand?agentId=${agentId}&brandId=${brandId}`;
export const GET_AGENT_BRAND_LIST = `${CHOCO_URL}/ops/agentBrands`;
export const ADD_AGENT_BRAND = `${CHOCO_URL}/ops/add/agentBrand`;
export const UPDATE_AGENT_BRAND = `${CHOCO_URL}/ops/update/agentBrand`;

export const GENERATE_INVOICE = `${CHOCO_URL}/ops/agent/generate-invoice`;
export const GET_MISMATCH_REQUESTS = (
  kimId: string,
  account: string,
  date: string
) =>
  `${CHOCO_URL}/ops/agent/mismatch-requests?kimId=${kimId}&account=${account}&date=${date}`;

export const UPDATE_MISMATCH_REQUEST_STATUS = `${CHOCO_URL}/ops/agent/update-mismatch-request-status`;
export const APPROVE_MISMATCH_REQUEST = `${CHOCO_URL}/ops/agent/mismatch/approve`;
export const GET_ALL_MISMATCH_REQUESTS = `${CHOCO_URL}/ops/mismatch-requests`;

export const GET_LEAVE_REQUESTS = `${CHOCO_URL}/ops/leave-requests`;
export const UPDATE_LEAVE_REQUEST_STATUS = `${CHOCO_URL}/ops/leave-request/update-status`;
export const GET_AGENT_LEAVE_BALANCE = (email: string, account: string) =>
  `${CHOCO_URL}/ops/agent/leave-balance?email=${encodeURIComponent(email)}&account=${encodeURIComponent(account)}`;

export const GET_AGENT_LOG_BY_ID = (id: string) =>
  `${CHOCO_URL}/tracker/log/${id}`;

export const DELETE_AGENT_LOG = `${CHOCO_URL}/ops/agent/log`;
export const CREATE_AGENT_LOG = `${CHOCO_URL}/ops/add/agent/log`;

// Agent
export const AGENT_SSO_LOGIN = `${CHOCO_URL}/ops/agent/sso-login`;
export const SEND_ONBOARDING_FORM = `${CHOCO_URL}/ops/onboarding`;

// Client
export const GET_CLIENT_LIST = `${CHOCO_URL}/ops/clients`;
export const ADD_CLIENT = `${CHOCO_URL}/ops/add/client`;
export const UPDATE_CLIENT = `${CHOCO_URL}/ops/update/client`;

// Invoice
export const GET_INVOICES = () => `${CHOCO_URL}/invoice/list`;
export const CREATE_INVOICE = `${CHOCO_URL}/invoice/create`;
export const UPDATE_INVOICE_BY_ID = (invoiceId: string) =>
  `${CHOCO_URL}/invoice/${invoiceId}`;
export const GENERATE_BRAND_INVOICES = (year: number, month: number) =>
  `${CHOCO_URL}/invoice/generate/brands/${year}/${month}`;
export const GENERATE_AGENT_INVOICES = (year: number, month: number) =>
  `${CHOCO_URL}/invoice/generate/agents/${year}/${month}`;

// Async Invoice Generation
export const GENERATE_AGENT_INVOICES_ASYNC = (year: number, month: number) =>
  `${CHOCO_URL}/invoice/generate-async/agents/${year}/${month}`;
export const GENERATE_CUSTOM_AGENT_INVOICES_ASYNC = `${CHOCO_URL}/invoice/generate-async/agents/custom`;
export const GENERATE_CLIENT_INVOICES_ASYNC = (year: number, month: number) =>
  `${CHOCO_URL}/invoice/generate-async/brands/${year}/${month}`;
export const GET_GENERATION_JOB_STATUS = (jobId: string) =>
  `${CHOCO_URL}/invoice/generation-status/${jobId}`;
export const LIST_GENERATION_JOBS = () =>
  `${CHOCO_URL}/invoice/generation-jobs`;
export const GET_GENERATION_HISTORY = (year: number, month: number) =>
  `${CHOCO_URL}/invoice/generation/history/${year}/${month}`;

// Assets
export const GET_ASSETS = (keys: string | string[]) =>
  `${CHOCO_URL}/ops/assets?keys=${keys}`;

// Elevate
export const ELEVATE_UPLOAD_PDFs = (id: string) =>
  `${ELEVATE_URL}/elevate/brands/${id}/pdfs/upload-multiple`;
// export const ELEVATE_GET_HEADINGS = (id: string, type: 'BK' | 'SR') =>
//   `${ELEVATE_URL}/api/v2/elevate/brands/${id}/headings?track=${type}`;
// export const ELEVATE_APPROVE_HEADINGS = (id: string, type: 'BK' | 'SR') =>
//   `${ELEVATE_URL}/api/v2/elevate/brands/${id}/headings/approve?track=${type}`;

// S3
export const GET_PRESIGNED_URL = (useCase: string, assetKey: string) =>
  `${CHOCO_URL}/aws/s3/generate-presigned-url?useCase=${useCase}&assetKey=${assetKey}`;
export const GET_DOWNLOAD_URLS = (keys: string[]) =>
  `${CHOCO_URL}/aws/s3/generate-multiple-download-urls`;
